import React from 'react';

type ActiveStatusProps = {
  status: 'active' | 'inactive';
  className?: string;
};

export const ActiveStatus: React.FC<ActiveStatusProps> = ({
  status,
  className = '',
}: ActiveStatusProps): JSX.Element => {
  return (
    <div className={`active-status active-status__${status} ${className}`}>
      {status}
    </div>
  );
};
